import * as constants from '../constants/actions';


/******************************
*******  Synchronous  *********
******************************/

export function commonAlert(text, config = {}) {
  return {
    type: constants.COMMON_ALERT,
    text,
    config,
  };
}

export function commonCloseAlert() {
	return {
    type: constants.COMMON_CLOSE_ALERT,
  };
}

export function commonModalResize() {
	return {
    type: constants.COMMON_MODAL_RESIZE,
  };
}


export function commonScrollTop(scroll) {
  return {
    type: constants.COMMON_SCROLL_TOP,
    scroll,
  };
}

export function commonScrollTo(scrollPos) {
  return {
    type: constants.COMMON_SCROLL_TO,
    scrollPos,
  };
}
  



/******************************
*******  Asynchronous  ********
******************************/

